export type ColumnType =
  | 'Text'
  | 'Number'
  | 'Date'
  | 'DateTime'
  | 'Percentage'
  | 'Currency'
  | 'Boolean'
  | 'URL';

export const COLUMN_TYPES: ColumnType[] = [
  'Text',
  'Number',
  'Date',
  'DateTime',
  'Percentage',
  'Currency',
  'Boolean',
  'URL',
];

export type AssignmentOrigin = 'inferred' | 'manual';

export interface Column {
  name: string;
  index: number;
  type: ColumnType;
  inferredType: ColumnType;
  assignmentOrigin: AssignmentOrigin;
}

export interface TypeAssignment {
  columnIndex: number;
  previousType: ColumnType;
  newType: ColumnType;
  timestamp: number;
}

export type ChartFieldRole = 'category' | 'numeric' | 'temporal' | 'any';

export interface ChartValidationResult {
  chartId: string;
  severity: 'error' | 'warning' | 'suggestion';
  message: string;
  affectedField: string;
  requiredRole: ChartFieldRole;
  actualType: ColumnType;
}

export interface ColumnTypeAssignment {
  column_index: number;
  column_name: string;
  column_type: ColumnType;
  inferred_type: ColumnType;
  assignment_origin: AssignmentOrigin;
}

export interface InferredColumn {
  column_index: number;
  column_name: string;
  inferred_type: ColumnType;
  confidence: number;
}
